import { ref } from 'vue'

// NOTE: The implementation below is inspired in useAPI from lw design-system
// there are some improvements in this version that is not available in DS version
// but if you is going to edit this code, please take look in this repository:
//
// https://dev.azure.com/locaweb/apps-design-system/_git/design-system?path=/src/functions/useAPI.js
export default ({ request, params: initialParams, decoder }) => {
  const loading = ref(false)
  const state = ref(null)
  const error = ref(false)
  const serverError = ref(null)
  const statusCode = ref(null)
  const responseHeaders = ref(null)
  const metaData = ref(null)

  async function execute ({ onSuccess, onError, ...newParams } = {}) {
    loading.value = true
    state.value = null
    metaData.value = null
    error.value = false
    serverError.value = null
    responseHeaders.value = null

    try {
      const params = { ...initialParams, ...newParams }
      const { data: { data, meta }, headers } = await request(params)

      metaData.value = meta
      responseHeaders.value = headers

      state.value = decoder?.(data) ?? data

      onSuccess?.(data, meta, headers)
    } catch ({ response }) {
      error.value = true
      statusCode.value = response?.status || null
      serverError.value = response?.data || null

      onError?.(response)
    } finally {
      loading.value = false
    }
  }

  return { data: state, meta: metaData, execute, loading, error, serverError, statusCode, responseHeaders }
}
